// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var LogType = /*#__PURE__*/function (LogType) {
  LogType["DEBUG"] = "DEBUG";
  LogType["ERROR"] = "ERROR";
  LogType["INFO"] = "INFO";
  LogType["WARN"] = "WARN";
  LogType["VERBOSE"] = "VERBOSE";
  LogType["NONE"] = "NONE";
  return LogType;
}(LogType || {});
export { LogType };
